// extracted by mini-css-extract-plugin
export default {"xl":"zZzjXJ","l":"bBhTKA","m":"xm6aI4","s":"C_1eC0","xs":"IMAnuE","xxs":"Ofiubx","elastic":"WfzAlc"};